import React,{useState} from "react";
import './index.css';
const TokensPercentage = ({currency})=>{
    const [threshold,setThreshold] = useState(0);
    function onChangeHandler(e){
        setThreshold(e.target.value);
    }
    return (
    <div className="tokens_percentage">
        <div className="input-group">
            <div className="prefix">
            {currency}
            </div>
            <input
                type="number"
                className="form-control form-control-md"
                disabled
                value={1}
            />
        </div>
        <div className="d-flex flex-row align-items-center justify-content-center">
            <input type="number" 
                name="threshold" 
                className="form-control form-control-md"
                onChange={onChangeHandler}
                value={threshold}
                min="1"
                max="50"
            />
            <p>%</p>
        </div>
        
    </div>);
}
export default TokensPercentage;


// WEBPACK FOOTER //
// ./src/components/TokensPercentage/index.js